import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';


const vuexLocal = new VuexPersistence({
  key: 'jagdnews',
  storage: window.localStorage
});

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    deviceId: null,
    favorites: []
  },
  mutations: {
    setDeviceId (state, id) {
      state.deviceId = id;
    },
    toggleFavorite (state, id) {
      let i;
      if ((i = state.favorites.indexOf(id)) > -1) {
        state.favorites.splice(i, 1);
      } else {
        state.favorites.push(id);
      }
    }
  },
  getters: {
    deviceId (state) {
      return state.deviceId;
    },
    favorites (state) {
      return state.favorites;
    }
  },
  plugins: [vuexLocal.plugin]
});

export default store;
